import { GridColDef, GridColumnDimensions } from '@mui/x-data-grid-premium'

const widthsFn = (screen: 'xs' | 'sm' | 'md' | 'lg' | 'xl', base: GridColumnDimensions) => {
  // tweak per size (examples; adjust to taste)
  if (screen === 'xs') return { ...base, name: 180, assignees: 90, orgId: 130 }
  if (screen === 'sm') return { ...base, name: 200, assignees: 100, orgId: 150 }
  if (screen === 'md') return { ...base, name: 220, assignees: 110, orgId: 170 }
  if (screen === 'lg') return { ...base, name: 260, assignees: 120, orgId: 180 }
  if (screen === 'xl') return { ...base, name: 520, assignees: 390, orgId: 450 }
  return { ...base, name: 300, assignees: 170, orgId: 210 } // xl
}
export const dynamicColumnWidths = (
  screen: 'xs' | 'sm' | 'md' | 'lg' | 'xl',
  base: GridColumnDimensions,
  columns: GridColDef[]
) => {
  // Prefer widthsFn values but fall back to column .width if defined
  const initialWidths = widthsFn(screen, base)
  const map = new Map<string, number>()
  columns.forEach(col => {
    const w = initialWidths[col.field] ?? (typeof col.width === 'number' ? col.width : undefined)
    if (typeof w === 'number') map.set(col.field, w)
  })
  return Object.fromEntries(map)
}
